import { render, staticRenderFns } from "./Services.vue?vue&type=template&id=22290144"
import script from "./Services.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./Services.vue?vue&type=script&charset=utf-8&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports